import React, { CSSProperties } from "react";
import * as styles from "./velavu-alert-modal-content.module.scss";
import { classArr } from "../../helper/style-helper";

export interface VelavuAlertModalContentProps {
	style?: CSSProperties;
	className?: string;
	children?: React.ReactNode;
}

export default function VelavuAlertModalContent(
	props: VelavuAlertModalContentProps,
) {
	return (
		<div
			style={props.style}
			className={classArr(styles.container, props.className)}
		>
			{props.children}
		</div>
	);
}
